export { default as RestaurantNews } from './RestaurantNews'
export { default as RestaurantNewsSkeleton } from './Skeleton'
